import ALCard from "../assets/images/al-card.png";

const al_card = {
    slug: "AL_Batiment_Carte_Visite",
    sections: [
        {
            elements: [
                { type: "title-prc", content: "Carte de visite AL Bâtiment" },
                { type: "tex-prc", content: "Mon premier projet professionnel : création complète d'une identité visuelle pour une entreprise du bâtiment, du logo à la carte de visite." },
                { type: "imageTitle", src: ALCard, alt: "Carte de visite AL Bâtiment" }
            ]
        },
        {
            elements: [
                { type: "title", content: "Premier projet professionnel" },
                { type: "text", content: "AL Bâtiment représente mon tout premier projet professionnel. Le client a entendu parler de mes services via le bouche-à-oreille dans mon réseau professionnel et m'a contacté pour concevoir sa carte de visite. Ce projet a été particulièrement formateur car il m'a permis de découvrir la réalité du travail avec un client et de mettre en pratique mes compétences." }
            ]
        },
        {
            elements: [
                { type: "title", content: "Le défi : partir de zéro" },
                { type: "text", content: "L'entreprise ne disposait d'aucune identité visuelle préexistante, pas même un logo. Ce projet nécessitait donc une approche complète : comprendre l'activité du client, identifier ses valeurs et ses besoins, puis créer de A à Z une identité visuelle cohérente et professionnelle." }
            ]
        },
        {
            elements: [
                { type: "title", content: "Création du logo" },
                { type: "text", content: "La première étape a été de concevoir un logo représentatif de l'entreprise. J'ai pris le temps d'échanger avec le client pour comprendre ses attentes et les valeurs qu'il souhaitait véhiculer : fiabilité, savoir-faire artisanal et professionnalisme. Le logo devait être simple, mémorable et adapté au secteur du bâtiment." }
            ]
        },
        {
            elements: [
                { type: "title", content: "Design de la carte de visite" },
                { type: "text", content: "Une fois le logo validé, j'ai pu concevoir la carte de visite. Le design adopte des codes visuels propres au secteur du bâtiment : palette de couleurs évoquant solidité et confiance (tons terre, gris ou bleu professionnel), typographie robuste et claire. La mise en page équilibrée met en valeur le nouveau logo et assure une excellente lisibilité des coordonnées." }
            ]
        },
        {
            elements: [
                { type: "title", content: "Une expérience formatrice" },
                { type: "text", content: "Ce projet m'a permis d'acquérir une expérience précieuse : gestion de la relation client, prise de brief, itérations sur les propositions, respect des délais et livraison finale. La satisfaction du client et l'utilisation quotidienne de sa carte de visite ont validé la qualité du travail réalisé. Cette première expérience professionnelle a posé les bases de ma méthodologie de travail." }
            ]
        }
    ]
};

export default al_card;